import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router';
// components
// import LoadingScreen from 'src/components/LoadingScreen.jsx';
import { pageOrder } from 'src/config/pageInfo/pageOrder.ts';
// guards
import { PATH_AFTER_LOGIN } from 'src/config.js';
import AuthGuard from 'src/guards/AuthGuard.jsx';
import GuestGuard from 'src/guards/GuestGuard.jsx';
import PageGuard from 'src/guards/PageGuard.jsx';
// Layouts
// import NoHeaderLayout from 'src/layouts/NoHeaderLayout.jsx';/
const NoHeaderLayout = lazy(() => import('src/layouts/NoHeaderLayout.jsx'));
const OnlineLayout = lazy(() => import('src/layouts/Online/OnlineLayout.jsx'));
const StaticPageLayout = lazy(() => import('src/layouts/StaticPageLayout.jsx'));

// import OnlineLayout from 'src/layouts/Online/OnlineLayout.jsx';
// import StaticPageLayout from 'src/layouts/StaticPageLayout.jsx';
// Pages
//* Components
const LoadingScreen = lazy(() => import('src/components/LoadingScreen.jsx'));
const LoginPage = lazy(() => import('src/pages/auth/Login.jsx'));
const LandingPagePage = lazy(() => import('src/pages/LandingPage.jsx'));
const LifeInfoAndDutyPage = lazy(() => import('src/pages/LifeInfoAndDuty.jsx'));
const GettingStartedOnlinePage = lazy(() => import('src/pages/online/GettingStartedOnline.jsx'));

const SaveAndEmailOnlinePage = lazy(() => import('src/pages/online/SaveAndEmailOnline.jsx'));

// const SaveAndEmailOnlinePage = lazy(() => import('src/pages/contactCenter/SaveAndEmailCC.jsx'));

const AboutYouInformationPage = lazy(
  () => import('src/pages/shared/prequalification/AboutYou.jsx'),
);

const AboutYouDeclarationsPage = lazy(
  () => import('src/pages/shared/prequalification/AboutYouDeclarations.jsx'),
);

const AcceptAndProceedPage = lazy(() => import('src/pages/online/AcceptAndProceed.jsx'));
const Page404Page = lazy(() => import('src/pages/Page404.jsx'));
const RetrieveQuoteOnlinePage = lazy(() => import('src/pages/online/RetrieveQuoteOnline.jsx'));
const PaymentContactDetailsPage = lazy(
  () => import('src/pages/shared/paymentPath/PaymentContactDetails.jsx'),
);
const PolicyPurchaseConfirmationPage = lazy(
  () => import('src/pages/shared/paymentPath/PolicyPurchaseConfirmation.jsx'),
);
const AlreadyDeclinedApplication = lazy(
  () => import('src/pages/shared/policyOutcome/AlreadyDeclinedApplication.jsx'),
);
const PolicyOutcomeDeclinePage = lazy(
  () => import('src/pages/shared/policyOutcome/PolicyOutcomeDecline.jsx'),
);
const QuoteSummaryPage = lazy(() => import('src/pages/shared/prequalification/QuoteSummary.jsx'));
const SelectCoverPage = lazy(() => import('src/pages/shared/prequalification/SelectCover.jsx'));
const YourDetailsContactPage = lazy(
  () => import('src/pages/shared/prequalification/YourDetailsContact.jsx'),
);
const RetrieveOutcomeBoundPage = lazy(
  () => import('src/pages/shared/retrieveOutcome/RetrieveOutcomeBound.jsx'),
);
const RetrieveOutcomeDeclinePage = lazy(
  () => import('src/pages/shared/retrieveOutcome/RetrieveOutcomeDecline.jsx'),
);
const RetrieveOutcomeExpiredPage = lazy(
  () => import('src/pages/shared/retrieveOutcome/RetrieveOutcomeExpired.jsx'),
);
const RetrieveLoadingPage = lazy(
  () => import('src/pages/shared/retrieveQuote/RetrieveLoading.jsx'),
);
const AboutYouDisclosurePage = lazy(
  () => import('src/pages/shared/underwriting/AboutYouDisclosure.jsx'),
);
const AboutYouQuestionsPage = lazy(
  () => import('src/pages/shared/underwriting/AboutYouQuestions.jsx'),
);
const ReviewApplicationPage = lazy(
  () => import('src/pages/shared/underwriting/ReviewApplication.jsx'),
);
// ** ONLINE PAYMENTS
const PaymentDetailsOnlinePage = lazy(() => import('src/pages/online/PaymentDetailsOnline.jsx'));
const PolicyOutcomeOnlinePage = lazy(() => import('src/pages/online/PolicyOutcomeOnline.jsx'));

import { PATH_ONLINE_SUB, PATH_ONLINE, PATH_SHARED_SUB } from './paths.js';

//* ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen isOnline={true} />}>
      <Component {...props} />
    </Suspense>
  );
};

//**  ---------------------------------------------------------------------- */
// ** AUTHENTICATION
const Login = Loadable(LoginPage);
// ** ONLINE
const AcceptAndProceed = Loadable(AcceptAndProceedPage);
//** GETTING STARTED ONLINE
const GettingStartedOnline = Loadable(GettingStartedOnlinePage);

//** Save and Email
const SaveAndEmailOnline = Loadable(SaveAndEmailOnlinePage);

// ** SHARED
const YourDetailsContact = Loadable(YourDetailsContactPage);
const SelectCover = Loadable(SelectCoverPage);
const QuoteSummary = Loadable(QuoteSummaryPage);
const AboutYouInformation = Loadable(AboutYouInformationPage);
const AboutYouDeclarations = Loadable(AboutYouDeclarationsPage);
// ** SHARED PAYMENT PATH
const PaymentContactDetails = Loadable(PaymentContactDetailsPage);
const PolicyPurchaseConfirmation = Loadable(PolicyPurchaseConfirmationPage);
const AboutYouDisclosure = Loadable(AboutYouDisclosurePage);
const AboutYouQuestions = Loadable(AboutYouQuestionsPage);
const PolicyOutcomeDecline = Loadable(PolicyOutcomeDeclinePage);
const ReviewApplication = Loadable(ReviewApplicationPage);
const RetrieveLoading = Loadable(RetrieveLoadingPage);
const RetrieveDecline = Loadable(RetrieveOutcomeDeclinePage);
const RetrieveReferredUW = Loadable(RetrieveOutcomeDeclinePage);
const RetrieveExpired = Loadable(RetrieveOutcomeExpiredPage);
const RetrieveBound = Loadable(RetrieveOutcomeBoundPage);
const RetrieveQuoteOnline = Loadable(RetrieveQuoteOnlinePage);
const ApplicationAlreadyDeclined = Loadable(AlreadyDeclinedApplication);
// ** ONLINE PAYMENTS
const PaymentDetailsOnline = Loadable(PaymentDetailsOnlinePage);
//** ONLINE POLICY OUTCOME
const PolicyOutcomeOnline = Loadable(PolicyOutcomeOnlinePage);
// ** Miscellaneous
const NotFound = Loadable(Page404Page);
const LandingPage = Loadable(LandingPagePage);
const LifeInfoAndDuty = Loadable(LifeInfoAndDutyPage);

//**  ---------------------------------------------------------------------- */

export default function RouterOnline() {
  const rootRedirect = 'true' === import.meta.env.VITE_ROOT_REDIRECT;

  return [
    {
      path: 'auth',
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
      ],
    },
    //* Online Routes.
    {
      path: PATH_ONLINE_SUB.root,
      element: (
        <AuthGuard>
          <OnlineLayout />
        </AuthGuard>
      ),
      children: [
        {
          element: <Navigate to={PATH_AFTER_LOGIN} replace />,
          index: true,
        },
        {
          path: PATH_ONLINE_SUB.accept,
          element: (
            <PageGuard>
              <AcceptAndProceed pageIndex={pageOrder.ACCEPT} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.gettingStarted,
          element: (
            <PageGuard>
              <GettingStartedOnline pageIndex={pageOrder.GETTING_STARTED} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.contact,
          element: (
            <PageGuard>
              <YourDetailsContact pageIndex={pageOrder.CONTACT} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.cover,
          element: (
            <PageGuard>
              <SelectCover pageIndex={pageOrder.COVER} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.quote,
          element: (
            <PageGuard>
              <QuoteSummary pageIndex={pageOrder.QUOTE} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.saveAndEmail,
          element: (
            <PageGuard>
              <SaveAndEmailOnline pageIndex={pageOrder.SAVE_AND_EMAIL} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.aboutYouInformation,
          element: (
            <PageGuard>
              <AboutYouInformation pageIndex={pageOrder.ABOUT_YOU_INFORMATION} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.aboutYouDeclarations,
          element: (
            <PageGuard>
              <AboutYouDeclarations pageIndex={pageOrder.ABOUT_YOU_DECLARATIONS} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.aboutYouDisclosure,
          element: (
            <PageGuard>
              <AboutYouDisclosure pageIndex={pageOrder.ABOUT_YOU_DISCLOSURE} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.aboutYouQuestions,
          element: (
            <PageGuard>
              <AboutYouQuestions pageIndex={pageOrder.ABOUT_YOU_QUESTIONS} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.aboutYourReview,
          element: (
            <PageGuard>
              <ReviewApplication pageIndex={pageOrder.REVIEW_APPLICATION} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.ppOnlinePolicyOutcome,
          element: (
            <PageGuard>
              <AuthGuard>
                <PolicyOutcomeOnline pageIndex={pageOrder.PP_ONLINE_POLICY_OUTCOME} />
              </AuthGuard>
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.ppPolicyOutcomeDecline,
          element: (
            <PageGuard>
              <PolicyOutcomeDecline pageIndex={pageOrder.PP_POLICY_OUTCOME_DECLINE} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.ppContact,
          element: (
            <PageGuard>
              <AuthGuard>
                <PaymentContactDetails pageIndex={pageOrder.PP_CONTACT} />
              </AuthGuard>
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.ppOnlinePayment,
          element: (
            <PageGuard>
              <AuthGuard>
                <PaymentDetailsOnline pageIndex={pageOrder.PP_ONLINE_PAYMENT} />
              </AuthGuard>
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.ppConfirmation,
          element: (
            <PageGuard>
              <AuthGuard>
                <PolicyPurchaseConfirmation pageIndex={pageOrder.PP_CONFIRMATION} />
              </AuthGuard>
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.retrieveQuoteLoading,
          element: (
            <PageGuard>
              <RetrieveLoading pageIndex={pageOrder.RETRIEVE_QUOTE_LOADING} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.retrieveDecline,
          element: (
            <PageGuard>
              <RetrieveDecline pageIndex={pageOrder.RETRIEVE_DECLINE} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.retrieveReferredUW,
          element: (
            <PageGuard>
              <RetrieveReferredUW pageIndex={pageOrder.RETRIEVE_REFERRED_UW} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.retrieveExpired,
          element: (
            <PageGuard>
              <RetrieveExpired pageIndex={pageOrder.RETRIEVE_EXPIRED} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.retrieveBound,
          element: (
            <PageGuard>
              <RetrieveBound pageIndex={pageOrder.RETRIEVE_BOUND} />
            </PageGuard>
          ),
        },
        {
          path: PATH_ONLINE_SUB.applicationAlreadyDeclined,
          element: (
            <PageGuard>
              <ApplicationAlreadyDeclined pageIndex={pageOrder.APPLICATION_ALREADY_DECLINED} />
            </PageGuard>
          ),
        },
      ],
    },
    {
      path: PATH_SHARED_SUB.infoAndDuty,
      element: <StaticPageLayout />,
      children: [{ element: <LifeInfoAndDuty />, index: true }],
    },
    {
      path: '/',
      ...(rootRedirect
        ? {
            element: <Navigate to={PATH_ONLINE_SUB.root} replace />,
          }
        : {
            element: <NoHeaderLayout />,
            children: [{ element: <LandingPage />, index: true }],
          }),
    },

    //* Online retrieve quote
    {
      path: PATH_ONLINE.retrieveQuote,
      element: <StaticPageLayout />,
      children: [{ element: <RetrieveQuoteOnline />, index: true }],
    },

    //* Main Routes
    {
      path: '*',
      element: <NoHeaderLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ];
}

//* ----------------------------------------------------------------
